"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextMessageEvent = exports.isMessageEvent = exports.isJoinEvent = exports.isCreateEvent = void 0;
const MatrixMessage_1 = require("../models/MatrixMessage");
function isCreateEvent(event) {
    return (event.type === 'm.room.create' && event.content instanceof Object && 'creator' in event.content);
}
exports.isCreateEvent = isCreateEvent;
function isJoinEvent(event) {
    return (event.type === 'm.room.member' &&
        event.content instanceof Object &&
        'membership' in event.content &&
        // eslint-disable-next-line dot-notation
        event.content['membership'] === 'join');
}
exports.isJoinEvent = isJoinEvent;
function isMessageEvent(event) {
    return event.type === 'm.room.message';
}
exports.isMessageEvent = isMessageEvent;
function isTextMessageEvent(event) {
    return (isMessageEvent(event) &&
        event.content instanceof Object &&
        'msgtype' in event.content &&
        // eslint-disable-next-line dot-notation
        event.content['msgtype'] === MatrixMessage_1.MatrixMessageType.TEXT);
}
exports.isTextMessageEvent = isTextMessageEvent;
//# sourceMappingURL=events.js.map